<template>
  <section>
    <div
      class='page-likes-mask'
      v-for="(item) in likeList"
      :key="item.key"
      :style="{'top': item.likesTop, 'left': item.likesLeft}"
    >
      <div class="heart heartAnimation"></div>
    </div>

  </section>
</template>

<script>
import '@/components/toucher/index';
import { apiAddPointup } from '@/api/live/index';

export default {
  name: 'likes-mask',
  data() {
    return {
      likesTop: 0,
      likesLeft: 0,
      likeList: [],
      pointupCount: 0,
      doubletimer: null,
      singletimer: null,
      doubleTap: false,
    };
  },
  props: {
    live: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    likeList(val) {
      if (val.length === 0) {
        if (this.live) {
          this.addPointup(this.pointupCount);
        } else {
          this.$pub.$emit('videoAddLike');
        }

        this.pointupCount = 0;
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.util.toucher(document.querySelector('.add-like'))
        .on('doubleTap', (e) => {
          clearTimeout(this.doubletimer);
          this.doubleTap = true;
          this.doubletimer = setTimeout(() => {
            this.doubleTap = false;
          }, 500);
          // 登录后才能点赞
          if (this.live) {
            if (this.$store.state.isImLogin) {
              this.addLikeAnimation(e);
            }
          } else if (window.sessionStorage.getItem('wyDbAuthtoken')) {
            if (this.$store.state.appRoute) {
              this.addLikeAnimation(e);
            }
          }
        });
      window.util.toucher(document.querySelector('.add-like'))
        .on('singleTap', () => {
          clearTimeout(this.singletimer);
          this.singletimer = setTimeout(() => {
            if (!this.doubleTap) {
              this.handleToggle();
            }
          }, 300);
        });
    });
  },
  methods: {
    addLikeAnimation(e) {
      this.pointupCount += 1;
      const x = e.clientX.toFixed(1) - 35;
      const y = e.clientY.toFixed(1) - 50;
      this.likesLeft = `${x}px`;
      this.likesTop = `${y}px`;
      this.likeList.push({
        likesTop: this.likesTop,
        likesLeft: this.likesLeft,
        key: new Date().getTime(),
      });
      setTimeout(() => {
        this.likeList.shift();
      }, 500);
    },
    handleToggle() {
      if (this.live) {
        // eslint-disable-next-line no-unused-expressions
        this.$player && this.$player.play();
      } else {
        // eslint-disable-next-line no-unused-expressions
        this.$player && this.$player.toggle();
      }
    },
    addPointup(val) {
      const { snowId } = this.$route.query;
      apiAddPointup({ videoId: snowId, pointupCount: val });
    },
  },
};
</script>

<style lang='less' scoped>
.page-likes-mask{
  position: absolute;
  .heart {
    background: url('~@/assets/img/live/heart_animation.png');
    background-position: left;
    background-repeat: no-repeat;
    height: 100px;
    width: 100px;
    cursor: pointer;
    position: absolute;
    left: -14px;
    background-size: 2900%;
  }
  @keyframes heartBlast {
    0% {
      background-position:left;
    }
    100% {
      background-position:right;
    }
  }
  .heartAnimation {
    display: inline-block;
    -webkit-animation-name: heartBlast;
    animation-name: heartBlast;
    -webkit-animation-duration: .8s;
    animation-duration: .8s;
    -webkit-animation-iteration-count: 1;
    animation-iteration-count: 1;
    -webkit-animation-timing-function: steps(28);
    animation-timing-function: steps(28);
    background-position: right;
  }
}
</style>
